import React, { FC, ReactElement, FormEvent, useState } from 'react';
import { sendQuestionMessage } from '../../../../api';
import { useSelector } from 'react-redux';
import { getEventKey } from '../../../../stores/reducers/userData';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import './demozone-question.sass';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';

interface Props {
  recepient: string
}

const DemoZoneQuestionForm: FC<Props> = ({ recepient }): ReactElement => {
  const [ message, setMessage ] = useState<string>('');
  const eventKey = useSelector(getEventKey);
  const location = useLocation();
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    successMessageSend_ru: 'Сообщение успешно отправлено',
    successMessageSend_en: 'Message sent successfully',
    errorMessageSend_ru: 'Ошибка отправки сообщения',
    errorMessageSend_en: 'Error sending message',
    // questionTitle_ru: `Есть вопрос ${recepient ? `про ${recepient.toLowerCase()}` : ''}?`,
    // questionTitle_en: `Have a question ${recepient ? `about ${recepient.toLowerCase()}` : ''}?`,
    questionTitle_ru: `Задать вопрос`,
    questionTitle_en: `Ask a Question`,
    message_ru: 'Сообщение',
    message_en: 'Message',
    // sendMesageButtonTitle_ru: 'Задать вопрос',
    // sendMesageButtonTitle_en: 'Ask a question',
    sendMesageButtonTitle_ru: 'Отправить',
    sendMesageButtonTitle_en: 'Send',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  const handlerSend = ((event: FormEvent): void => {
    event.preventDefault();
    const payload = {
      page: location.pathname.split('/')[1],
      to: recepient,
      message
    };
    
    sendQuestionMessage(eventKey, payload)
      .then(response => {
        if (response.status === 200) {
          toast.success(localizedName('successMessageSend_ru'));
          setMessage('');
        } else {
          toast.error(localizedName('errorMessageSend_ru'));
        }
      })
      .catch(error => {
        toast.error(localizedName('errorMessageSend_ru'));
      });
  });

  return (
    <>
      <section className="inner-section">
        <div className="container">
          <div className="inner-section__head">
            <div className="section-title">{ localizedName('questionTitle_ru') }</div>
          </div>

          <form className="demozone-form" onSubmit={(e) => handlerSend(e)}>
            <label className="demozone-input-wrapper w-100">
              <span className="demozone-input__label">{ localizedName('message_ru') }</span>                
              <textarea 
                id="message" 
                name="message" 
                className="demozone-input__field textfield"
                onChange={(e) => setMessage(e.target.value)}
              />
            </label>

            <button className="btn btn-primary btn--mobile-min bg-footer demozone-form__btn" type="submit">
              { localizedName('sendMesageButtonTitle_ru') }
            </button>
          </form>  
        </div>
      </section>
    </>
  )
}

export default DemoZoneQuestionForm
